import userApi from "../../api/userApi";
import { setRootCookie, delRootCookie } from "../../utils/cookie";

// import { setDefaultAxiosHeader } from "@/common/plugins/addAxiosConfig";
import { Store } from "vuex";
let api = new userApi();

// initial state
const state = {
  api: api,
  isLogined: false,
  userInfo: undefined,
};

// getters
const getters = {
  getUserInfo: state => state.userInfo,
  isLogined: state => state.isLogined,
  getApi: state => state.api
};

// actions
const actions = {
  // 更新用户信息
  async updateUserInfo({ commit, state }) {
    try {
      let res = await state.api.getUserInfo()
      if (res.status !== true || res.code !== 200) {
        throw new Error("获取用户信息失败")
      }
      if (res.data && res.data.id) {
        commit("setUserInfo", res.data);
      } else {
        commit("setUserInfo", null);
      }
    } catch (e) {
      commit("setUserInfo", null);
      // throw new Error(e)
    }
  },
  // 登出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      state.api.logout().then(() => {
        commit("setUserInfo", null);
        resolve()
      }, err => {
        reject(err)
      });
    })
    // await state.api.logout();
    // commit("setUserInfo", null);
  },
  // 登入
  async login({ commit, state }, payload = {}) {
    try {
      let res = await state.api.login(payload)
      if (!res.status) {
        commit("setCookie", { token: "" });
        switch (res.code) {
          case 600: {
            return { status: false, msg: "PASSWORD_USERNAME_ERROR" };
          } break;
          // case 601: {
          //   return { status: false, msg: "PASSWORD_USERNAME_ERROR" };
          // } break;
          case 603: {
            return { status: false, msg: "AUTHORIZATION_TIMEOUT_ERROR" };
          } break;
          default: {
            return { status: false, msg: "UNKNOWN_ERROR" }
          }
        }
      }
      commit("setCookie", { token: res.data.token })
      // TODO: update user info 
      return { status: true, msg: undefined }
    } catch (e) {
      return { status: false, msg: "NETWORK_ERROR" }
    }
  },
  //获取绑定/解绑手机号验证码
  async getCode({ commit, state }, payload = { mobile: "", category: "" }) {
    let res = await state.api.getCaptcha({ mobile: payload.mobile, category: payload.category });
    return res
  },
  //绑定手机号
  async bindMobile({ commit, state }, payload = { mobile: undefined, captcha: undefined }) {
    let res = await state.api.bindMobile({ mobile: payload.mobile, captcha: payload.captcha });
    return res
  },
  //解绑手机号
  async unBindMobile({ commit, state }, payload = { mobile: undefined, captcha: undefined }) {
    let res = await state.api.unBindMobile({ mobile: payload.mobile, captcha: payload.captcha });
    return res
  },
  //修改密码
  async changePasswd({ commit, state }, payload = { password: undefined, new_password: undefined }) {
    let res = await state.api.changePasswd({ password: payload.password, new_password: payload.new_password });
    return res
  },
  //重置密码
  async resetPasswd({ commit, state }, payload = { mobile: undefined, captcha: undefined, password: undefined }) {
    let res = await state.api.resetPasswd({ mobile: payload.mobile, captcha: payload.captcha, password: payload.password });
    return res
  },
};

// mutations
const mutations = {
  // 设置用户信息
  setUserInfo(state, payload = {}) {
    let _isLogined = false;
    if (payload && payload.id) {
      // 存在用户信息
      _isLogined = true;
    }
    state.userInfo = payload;
    state.isLogined = _isLogined;
  },
  setCookie(state, payload = {}) {
    //设置本域cookie, key-value-expired_day
    setRootCookie("qmovie_token", payload.token, 7)
  },
  // logout(state) {
  //   state.isLogined = false
  //   delRootCookie("qmovie_token")
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
